import { ApiService } from './ApiService'
import {
  IApiIndividualResponse,
  IPaginationParams,
  ISortingParams,
} from '@/types/api'
import { IOrder, OrderStatus } from '@/types/order'
import qs from 'qs'

export type IOrderPostPayload = Pick<
  IOrder,
  'item' | 'paymentTerm' | 'currency' | 'totalAmount' | 'status'
>

export type IOrderPatchPayload = Partial<IOrder>

export interface IOrderGetFilters {
  itemId?: string // At the current context this is the courseId
  userId?: string
  status?: OrderStatus | OrderStatus[]
  include?: string[]
}

export type ICategoryGetParams = {
  filters?: IOrderGetFilters
  pagination?: IPaginationParams
}

export class OrderService extends ApiService {
  static GET_PATH = `/orders`
  static POST_PATH = `/orders`
  static PATCH_PATH = `/orders/:id`

  static async getOrders(
    filters: IOrderGetFilters = {},
    pagination: IPaginationParams = {},
    groupBy?: string,
    sort?: ISortingParams
  ) {
    const queryString = qs.stringify({
      ...filters,
      ...pagination,
      ...(groupBy && { groupBy }),
      ...(sort && {
        sort: Object.entries(sort).reduce((acc, [fieldName, sortValue]) => {
          return [...acc, `${fieldName}[${sortValue}]`]
        }, []),
      }),
    })

    return ApiService.get(`${OrderService.GET_PATH}?${queryString}`)
  }

  static async getOrdersGroupedByStatus(
    filters: IOrderGetFilters = {},
    pagination: IPaginationParams = {}
  ) {
    const queryString = qs.stringify({
      ...filters,
      ...pagination,
      groupBy: 'status',
    })

    return ApiService.get(`${OrderService.GET_PATH}?${queryString}`)
  }

  static async postOrder(
    order: IOrderPostPayload
  ): Promise<IApiIndividualResponse<IOrder>> {
    return ApiService.post(OrderService.POST_PATH, order)
  }

  static async patchOrder(
    orderId: string,
    order: IOrderPatchPayload
  ): Promise<IApiIndividualResponse<IOrder>> {
    return ApiService.patch(
      OrderService.PATCH_PATH.replace(':id', orderId),
      order
    )
  }
}
